import { useState } from "react";
import { useParams } from "react-router";

import { EmvConfigurationEditForm } from "src/app/features/EmvKernelProfile/subFeatures/EmvConfiguration/components/forms/EmvConfigurationEditForm";
import { ActionBar } from "../../../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../../../components/AppLayout/components/FPageLayout";
import { BackButton } from "../../../../../../components/FeatureButtons/BackButton";
import { SubmitButton } from "../../../../../../components/FeatureButtons/SubmitButton";
import { ResourceName, ResourceVariant } from "../../../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../../../core/router/types/routerTypes";

export const EmvConfigurationEditFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);

    const { emvKernelProfileId } = useParams();
    const backUrl = `${BASE_PATH}/${ResourceName.EMV_KERNEL_PROFILES}/${ResourceVariant.APAC}/${FORM_ACTION.EDIT}/${emvKernelProfileId}`;

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.emvConfigurationsEditFormPage" />
                <ActionBar>
                    <SubmitButton isDisabled={false} onClick={triggerFormSubmit} />
                    <BackButton isDisabled={false} url={backUrl} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <EmvConfigurationEditForm runSubmit={runSubmit} />
            </FPageContent>
        </FPage>
    );
};
